"use client";

// 予期しないサーバー/クライアントエラーの最終受け皿。
//
// これが無いと (authed)/layout.tsx などサーバー側の throw がそのまま素の 500 に
// なり、ブラウザ既定の「このページを読み込めませんでした」= 行き止まりの画面が
// 出る。standalone (PWA) では戻る導線も乏しいので特に困る。
//
// global-error は root layout ごと差し替わるため html/body を自前で持つ必要が
// ある (Next.js の仕様)。同じ理由でフォント変数とテーマ初期化スクリプトも
// layout.tsx から複製している — ダークモードはクラスベース (globals.css の
// @custom-variant) なので、.dark を付けないと dark: が効かない。

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="ja" className="h-full antialiased">
      <body className="min-h-full flex flex-col">
        {/* layout.tsx と同じ FOUC 防止スクリプト (描画前に .dark を確定させる) */}
        <script
          dangerouslySetInnerHTML={{
            __html: `try{var t=localStorage.getItem('theme');if(t==='dark'||(!t&&window.matchMedia('(prefers-color-scheme: dark)').matches)){document.documentElement.classList.add('dark')}else{document.documentElement.classList.remove('dark')}}catch(e){}`,
          }}
        />
        <main className="min-h-screen bg-zinc-50 dark:bg-black flex items-center justify-center px-6">
          <div className="w-full max-w-sm text-center">
            <h1 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
              読み込めませんでした
            </h1>
            <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed">
              一時的な問題の可能性があります。再読み込みで直らない場合は、
              ログインし直してみてください。
            </p>
            <div className="mt-6 flex items-center justify-center gap-2">
              <button
                type="button"
                onClick={() => reset()}
                className="rounded-xl bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900 text-sm px-4 py-2 hover:opacity-90 transition-opacity"
              >
                再読み込み
              </button>
              <a
                href="/login"
                className="rounded-xl border border-zinc-300 dark:border-zinc-700 text-sm px-4 py-2 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-900 transition-colors"
              >
                ログインし直す
              </a>
            </div>
            {/* digest はサーバー側のログ (CloudWatch) と突き合わせるための ID。
                エラー内容そのものは含まれないので表示してよい。 */}
            {error.digest && (
              <p className="mt-6 text-[11px] text-zinc-400 dark:text-zinc-600 tabular-nums">
                エラー ID: {error.digest}
              </p>
            )}
          </div>
        </main>
      </body>
    </html>
  );
}
